module.exports = __webpack_public_path__ + "images/project-description-84bcdfad5f8e6d3d18f4b6375ee1ac93.jpg";